import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ReviewReasonComponent } from 'src/app/admin/components/review-reason/review-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let require: any;
const FileSaver = require('file-saver');
@Component({
  selector: 'app-admin-financial',
  templateUrl: './admin-financial.component.html',
  styleUrls: ['./admin-financial.component.css'],
})
/**
 * AdminFinancialComponent handles the financial administration functionalities for incubators.
 *
 * This component is responsible for:
 * - Fetching and displaying financial data for a selected incubator.
 * - Approving or rejecting financial requests with appropriate status updates.
 * - Downloading related documents.
 * - Displaying and managing guidelines.
 * - Handling responsive UI changes for mobile devices.
 *
 * It interacts with various services for API calls, notifications, dialogs, and UI updates.
 *
 * @remarks
 * - Uses reactive forms for status updates.
 * - Loads guideline data from a local JSON file.
 * - Utilizes session storage to retrieve incubator information.
 *
 * @example
 * // Usage in a template
 * <app-admin-financial></app-admin-financial>
 */
export class AdminFinancialComponent implements OnInit {
  updateForm: FormGroup;
  private getApi = environment.url + environment.financialGet;
  private updateStatusApi = environment.url + environment.updateStatus;
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private getdata: ValueService,
    private fb: FormBuilder,
    private makeapi: ApiService,
    public dialog: MatDialog,
    private notify: NotifyService,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    this.updateForm = this.fb.group({
      incubatorId: [''],
    });
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  //
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  incubaterName;
  ngOnInit(): void {
    this.incubaterName = sessionStorage.getItem('adminIncubName');
    let getform = this.updateForm.value;
    getform.incubatorId = sessionStorage.getItem('incubator');
    this.updateForm.patchValue(getform);
    this.getDataApi();
    this.guidelineDatas();
  }
  getValue: any = {};
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('incubator'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
      });
  }
  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  download(value) {
    const pdfUrl = value;
    const pdfName = 'your_pdf_file';
    FileSaver.saveAs(pdfUrl, pdfName);
  }
  approveBtn(keys, id) {
    const fc = new FormControl('');
    this.updateForm.addControl(keys, fc);
    this.updateForm.controls[keys].setValue(id);
    this.getdata.amizhthLoader('show');
    let getform = this.updateForm.value;
    this.makeapi
      .method(this.updateStatusApi, getform, 'post')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          this.updateForm.removeControl(keys);
          this.getDataApi();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
  }

  rejectBtn(keys, id) {
    const fc = new FormControl('');
    this.updateForm.addControl(keys, fc);
    this.updateForm.controls[keys].setValue(id);
    this.getdata.amizhthLoader('show');
    let getform = this.updateForm.value;
    this.makeapi
      .method(this.updateStatusApi, getform, 'post')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          this.updateForm.removeControl(keys);
          this.getDataApi();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  reviewBtn(key, status) {
    const dialogRef = this.dialog.open(ReviewReasonComponent, {
      width: '390px',
      data: { _key: key, _status: status },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getDataApi();
    });
  }
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  guidelineDatas() {
    this.http.get('/assets/json/guideline.json').subscribe((data) => {
      this.guidelineValue = data[2].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.step++;
  }
  prevStep() {
    this.step--;
  }
}
